import { connection } from '@/api/connection'
import pickBy from 'lodash/pickBy'

export default {
  getFactoringScheduleInvoicesByFilters: (filters) => connection.get('bo/factoring/schedule/invoices', {
    params: pickBy(filters)
  }),
  putFactoringScheduleInvoiceDeadline: (payload) => connection.put('/bo/factoring/schedule/invoices', payload)
}
